import { createSelector } from 'reselect';
import { getMachine } from 'lib/selectors/getMachine';

export const getIsMesBehaviorMode = createSelector([getMachine], (machine) => {
  return machine?.autostartBehavior === 'mes';
});
